var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:_vm.b()},[_c('borrower-statement-table-head',{attrs:{"totals":_vm.updatedTotals}}),_c('borrower-statement-table-body',{attrs:{"totals":_vm.updatedTotals,"entries":_vm.entries,"currency":_vm.currency}}),(_vm.showDetail)?_c('borrower-statement-table-footer',{attrs:{"totals":_vm.updatedTotals,"currency":_vm.currency}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }